import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSessionBlocked } from '@/stores/sessionTransition';

/** Hold the mounted route and restore the current history entry while paused. */
export function useRecoveryLocation() {
  const location = useLocation();
  const navigate = useNavigate();
  const paused = useSessionBlocked();
  const held = useRef({ location, index: window.history.state?.idx as number | undefined });
  if (!paused) held.current = { location, index: window.history.state?.idx };
  useLayoutEffect(() => {
    const target = held.current;
    const index = window.history.state?.idx;
    const movedEntry = typeof index === 'number' && typeof target.index === 'number' && index !== target.index;
    if (paused && (movedEntry || location.pathname !== target.location.pathname || location.search !== target.location.search || location.hash !== target.location.hash)) {
      // A POP must return to the held entry, not overwrite the previous page.
      if (movedEntry) {
        navigate(target.index! - index);
      } else {
        navigate(target.location, { replace: true });
      }
    }
  }, [paused, location, navigate]);
  return paused ? held.current.location : location;
}
